<template>
  <div
    class="chip-button"
    :class="[color,{width200:width200}]"
    @click.stop="onClick()"
  >
    <div class="thumbnail">
      <i :class="icon" />
    </div>
    <p class="text">
      {{ textLabel }}
    </p>
  </div>
</template>
<script>
export default {
  name: "ChipButton",
  props: {
    width200: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "icon-alert-cancel",
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
.chip-button {
  @include flex;
  @include flex_align;
  padding: 4px 26px 4px 4px;
  border-radius: 40px;
  background-color: var(--white);
  cursor: pointer;
  &.width200 {
    min-width: 200px;
    .text {
      margin: 0 auto;
    }
  }
  &.gray {
    border: solid 1px #d8d8d8;
    .thumbnail {
      background-color: var(--gray-700);
    }
    .text {
      color: var(--gray-700);
    }
  }
  &.yellow {
    border: solid 1px var(--yellow-700);
    .thumbnail {
      background-color: var(--yellow-700);
    }
  }
  &.red {
    border: solid 1px var(--red-500);
    .thumbnail {
      background-color: var(--red-500);
    }
  }
  .thumbnail {
    @include flex_align;
    justify-content: center;
    flex: 0 0 36px;
    height: 36px;
    border-radius: 50%;
    i {
      font-size: 1.5rem;
      color: var(--white);
    }
  }
  .text {
    @include auto_margin_left(14px);
    font-size: 0.875rem;
    font-weight: bold;
    line-height: 1.43;
    letter-spacing: 1px;
    white-space: nowrap;
    color: var(--gray-900);
  }
}
</style>